/*
 *   File :  success-confirmation.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description :  Success confirmation order
 *   Integrations :
 *   Version : v1.0
 */

/*import packages*/
import React, { useState, useEffect } from 'react';

/*import styles*/
import styles from '../../styles/components/fundClass.module.scss';
import { SecondaryBtn, PrimaryBtn } from '../cta';

import devconfig from '../../config/config';
import APIPost from '../../services/postApi';
import { Toast } from '../note';

/*import components*/

export default function DeleteScheduledMessage(props) {
    const [toastMessage, setToastMessage] = useState(null);


    useEffect(() => {
        var my_modal = document.getElementById("delete-schedule-message");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.handleCloseModal();
        });
        //eslint-disable-next-line
    }, [props.handleCloseDateModal]);

    useEffect(() => {
        if (toastMessage !== null) {
            setTimeout(() => {
                setToastMessage(null);
            }, 4000);
        }
    }, [toastMessage])

    const _handleCloseModal = () => {
        document.getElementById("close-pscm").dispatchEvent(new Event("click"));
    };

    const _cancelSchedule = () => {
        const url = devconfig.admin + "/notification/delete-scheduled-notification";
        let payload = JSON.stringify({
            schedule_id: props.id
        });
        APIPost(url, payload).then((response) => {
            if (response.status_code === 200) {
                setToastMessage({ type: 'success', message: 'Message has been deleted' });
                setTimeout(() => {
                    _handleCloseModal();
                    props.success();
                }, 1000);
            } else {
                setToastMessage({ type: 'error', message: response.message });
            }
        })
    }


    return (
        <div className={`${styles.e_add_fund} modal fade`}
            id={"delete-schedule-message"}
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="delete-schedule-message"
            aria-hidden="true">
            <div className={`${styles.e_modal_dialog} modal-dialog modal-dialog-centered`}>
                <div className="modal-content">
                    <button id="close-pscm"
                        type="button"
                        className="btn-close d-none"
                        data-bs-dismiss="modal"
                        onClick={_handleCloseModal} >
                    </button>
                    <img src={props.resume ? require("../../assets/images/modal/successs.png").default : require("../../assets/images/modal/delete-icon.png").default}
                        alt="success"
                        width={62}
                        height={62}
                        className='mx-auto mt-1' />
                    <h6 className='pt-4 mt-3 mb-4 pb-2 text-center'>{props.message}</h6>
                    <div className="row pb-1">
                        <div className="col-lg-12">
                            <div className="d-flex justify-content-center gap-3">
                                {
                                    // props.resume ?
                                    //     <PrimaryBtn
                                    //         name="Resume"
                                    //         handleClick={_cancelSchedule}
                                    //     />
                                    //     :
                                        <SecondaryBtn
                                            name="Delete"
                                            className='e-modal-submit-red'
                                            handleClick={_cancelSchedule} />
                                }

                                <SecondaryBtn
                                    name="Cancel"
                                    className={`${styles.e_cancel} e-cancel`}
                                    cancel="modal" />
                            </div>

                        </div>
                    </div>
                </div>
            </div >
            {
                toastMessage !== null ?
                    <Toast data={toastMessage.message}
                        type={toastMessage.type}
                        id="2" />
                    :
                    null
            }
        </div>

    )
}
